import { ViewType } from '@/catalogs/api/runtime/IRouteData';
import { CatalogProductSwitchDisplayModeOption } from '@/catalogs/api/configuration/components/ICatalogProductSwitchOptions';

export const routeMap: Record<CatalogProductSwitchDisplayModeOption, ViewType> = {
  [CatalogProductSwitchDisplayModeOption.catalog]: 'catalogs',
  [CatalogProductSwitchDisplayModeOption.product]: 'products',
  [CatalogProductSwitchDisplayModeOption.alias]: 'aliases',
};
